module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAcUlEQVRIie2Puw2AMBQDHRZjnJSMAqlgWo6CIEFEIj5BNO9qy2dLhmH8B+CA9kKuBdyT8gDMQFfI+ZiZcpKm5JHkJPVnEsBLGmPmPvHFwMrhyW45pfWPJNXKE0nYSbby8Lo886TO8oKkfnki+abcMLIsXdC+QY2m3bcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/demo-profile/arrow-down.png
// module id = tHX/
// module chunks = 1